import { useMemo } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'

export function useTranslatedStyleLinks() {
  const {
    pages: {
      product: {
        styleLinks: { styles },
      },
    },
  } = useTranslation()

  const translatedStyleLinks: Record<string, { title: string; handle: string }[]> = useMemo(
    () => ({
      'womens-zamora-scrub-pants': [
        {
          title: styles.highWaisted,
          handle: 'womens-zamora-high-waisted-yoga-waistband-scrub-pants',
        },
      ],
      'womens-zamora-high-waisted-yoga-waistband-scrub-pants': [
        {
          title: styles.midRise,
          handle: 'womens-zamora-scrub-pants',
        },
      ],
      /**
       * Uman - High Waisted/Mid-Rise
       */
      'womens-uman-jogger-scrub-pants': [
        {
          title: styles.highWaisted,
          handle: 'womens-high-waisted-uman-scrub-pants',
        },
      ],
      'womens-high-waisted-uman-scrub-pants': [
        {
          title: styles.midRise,
          handle: 'womens-uman-jogger-scrub-pants',
        },
      ],
      /**
       * Rafaela ScrubJumpsuit - Jogger/Wide Leg
       */
      'womens-rafaela-cargo-wide-leg-scrub-jumpsuit': [
        {
          title: styles.jogger,
          handle: 'womens-rafaela-jogger-scrubjumpsuit',
        },
      ],
      'womens-rafaela-jogger-scrubjumpsuit': [
        {
          title: styles.wideLeg,
          handle: 'womens-rafaela-cargo-wide-leg-scrub-jumpsuit',
        },
      ],

      /**
       * Salta Underscrub - Longsleeve/Shortsleeve
       */

      'womens-salta-shortsleeve-underscrub': [
        {
          title: styles.longsleeve,
          handle: 'womens-salta-under-scrubs',
        },
      ],
      'womens-salta-under-scrubs': [
        {
          title: styles.shortsleeve,
          handle: 'womens-salta-shortsleeve-underscrub',
        },
      ],

      /* Mens */
      /**
       * Makato Underscrub - Longsleeve/Shortsleeve
       */
      'mens-makato-shortsleeve-underscrub': [
        {
          title: styles.longsleeve,
          handle: 'mens-makato-longsleeve-underscrub',
        },
      ],
      'mens-makato-longsleeve-underscrub': [
        {
          title: styles.shortsleeve,
          handle: 'mens-makato-shortsleeve-underscrub',
        },
      ],
      /**
       * Supersoft Underscrub - Longsleeve/Shortsleeve
       */
      'mens-new-supersoft-longsleeve-underscrub': [
        {
          title: styles.shortsleeve,
          handle: 'mens-new-supersoft-shortsleeve-underscrub',
        },
      ],
      'mens-new-supersoft-shortsleeve-underscrub': [
        {
          title: styles.longsleeve,
          handle: 'mens-new-supersoft-longsleeve-underscrub',
        },
      ],
    }),
    [styles]
  )

  return translatedStyleLinks
}
